module.exports = __webpack_public_path__ + "static/img/bszn_bg.e056160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/bszn_bg.png
// module id = JDis
// module chunks = 1